export default class customer {
    account_no = "";
    company = "Cellfind";
    name = "";
    registration_no = "";
    vat_no = "";
    country = "ZA";
    physical = "";
    postal = "";
    image = null;
    sales = null;
    business = null;
    technical = null;
    financial;
}
